import {reactive} from 'vue'
import {profileFor} from '@/localeProfiles'

// Store neni komponenta, takze bere jazyk z build-time env, ne z i18n locale.
// Komponenty pouzivaji useLocaleProfile() — ten je reaktivni kvuli debug prepinaci.
const profile = profileFor(import.meta.env.VITE_LANGUAGE);

export const store = reactive({
    debug: false,
    apiDebug: false,
    gaSwitch: true,
    form: {
        currentStep: 'stepOne',
        steps: {
            'stepOne': {
                filled: false,
                blurred: false,
                visited: true,
            },
            'stepTwo': {
                filled: false,
                blurred: false,
                visited: false,
            },
            'stepThree': {
                filled: false,
                blurred: false,
                visited: false,
            },

        },
        formEditing: false, // pro "opravdu odejít" popup
        currency: import.meta.env.VITE_CURRENCY, // NOTE: nastavení měny pro košík (EUR|CZK)
        profile: profile, // NOTE: profil jazykové mutace, viz src/localeProfiles.js
        language: profile.isLang, // NOTE: odesílá se do raynet - info v jaké jazykové mutaci je formulář (CZ|EN|SK)
        priceListName: 'Ceník ' + import.meta.env.VITE_CURRENCY, // NOTE: nastavení ceníku pro košík (Cenik EUR|Cenik CZK)
        druhyZivnostiCodes: ['ZU02', 'ZU03', 'ZU06', 'ZU04', 'OS01'], // slouzi pro vyhledani a doplneni cen
        druhyZivnostiProducts: [],
        seatsCodes: [
            'SP10', //ID1
            'SP12', //95
            'SP03', // 33
            'SP09',
            'SP02',
            'SP01',
            'SP11',
            'SP20',
            'SP05_12',
        ],
        defaultSeatCode: 'SP05_12',
        seatsProducts: [],
        sameInvoiceAddressOwnSeat: false,
        formSucceed: false,
        formSending: false,
    },

    order: {
        type: 'order',
        contactInfo: {
            firstName: '',
            surName: '',
            email: '',
            phone: '',
            phoneCountry: null,
            phoneCountryCustom: null,
            street: '',
            city: '',
            country: null,
            otherCountry: '',
            psc: '',
        },
        cinnost: 'main',
        oborZivnosti: '',
        regstrationToFlatRateTax: false,
        taxReturnPreparationService: false,
        paymentType: '',
        healthInsurance: '',
        economicActivity: '',
        seatChoose: '',
        ownSeatAddress: {

            street: '',
            city: '',
            country: 'Česká republika',
            psc: ''
        },
        checkAgreement: false,
        products: [],
        payments: {},
        raynetLeadId: null,
        residency: ''
    },

    urls: {
        //jakeSwissUrl: 'https://swiss-dev-dot-jake-james-web-cz-220909.ey.r.appspot.com'
        // jakeSwissUrl: 'https://jake-james-tools.ey.r.appspot.com'
        jakeSwissUrl: import.meta.env.VITE_JAKE_SWISS_URL,
        // jakeSwissUrl: 'http://localhost:800'
    },

    getVatForProduct(product) {
        var result = product.prices.find(element => element.priceListName === this.priceListName);
        if (result.vatRate.vatRate === 0) return 1;
        return (result.vatRate.vatRate / 100) + 1;
    },

    calcOrderTotalPriceNoVat() {
        var price = 0;
        if (this.order.products.length > 0) {
            for (const element of this.order.products) {
                if (element.type === 'seat') {
                    price += element.totalPriceWithoutVat;
                } else{
                    price += element.prices.find(price=>price.currency.priceListName === this.form.priceListName).price;
                }
            }
            return price;
        } else return 0;

    },
    calcOrderTotalPriceWithVat() {
        var price = 0;
        if (this.order.products.length > 0) {
            for (const element of this.order.products) {
                if (element.type === 'seat') {
                    price += element.totalPriceWithVat;
                } else{
                    price += element.prices.find(price=>price.currency.priceListName === this.form.priceListName).price * this.getVatForProduct(element);
                }
            }
            return price;
        } else return 0;

    },
    // product from json
    getProduct(code) {
        return this.products.find(element => element.code === code);
    },
    getOrderProduct(code) {
        return this.order.products.find(element => element.code === code);
    },
    addProduct(code) {
        if (!this.isProductInOrder(code))
            this.order.products.push(this.getProduct(code));
    },
    removeProduct(code) {
        if (this.isProductInOrder(code)) {
            const findIndex = this.order.products.findIndex(a => a.code === code)
            findIndex !== -1 && this.order.products.splice(findIndex, 1)

        }
    },
    // Přepne store na jinou jazykovou mutaci — profil, měnu, ceník a hodnotu do Raynetu.
    // V sestaveném balíčku se nevolá: mutace je daná buildem a locale se za běhu nemění.
    // Slouží debug přepínači jazyka v App.vue, aby se s jazykem přepnul i košík.
    applyProfile(profile) {
        this.form.profile = profile;
        this.form.language = profile.isLang;
        this.form.currency = profile.currency;
        this.form.priceListName = 'Ceník ' + profile.currency;
    },
    isProductInOrder(code) {
        return this.order.products.find(elemenet => elemenet.code === code);
    },
    priceFilter(price) {
        var modulo = price % 1;
        if (!modulo)
            return this.formatPriceNoFraction(price)
        else
            return this.formatPriceFraction(price)
        // var formatter = new Intl.NumberFormat('cs', {
        //     style: 'currency',
        //     currency: this.form.currency,
        //     maximumFractionDigits: 0,
        //     minimumFractionDigits: 0
        // });
        // return formatter.format(price);
    },
    formatPriceNoFraction(price) {
        if (this.form.profile.priceFormat)
            return this.formatSymbolNoFraction(price);
        else
            return this.formatCodeNoFraction(price);

    },
    formatPriceFraction(price) {
        if (this.form.profile.priceFormat)
            return this.formatSymbolFraction(price);
        else
            return this.formatCodeFraction(price);
    },
    formatSymbolNoFraction(price) {
        var formatter = new Intl.NumberFormat(store.form.profile.priceFormat, {
            style: 'currency',
            currency: store.form.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        return formatter.format(price)
    },
    formatSymbolFraction(price) {
        var formatter = new Intl.NumberFormat(store.form.profile.priceFormat, {
            style: 'currency',
            currency: store.form.currency,
            maximumFractionDigits: 2
        });
        return formatter.format(price)
    },
    formatCodeNoFraction(price) {
        const number = new Intl.NumberFormat('cs-CZ', {
            style: 'decimal',
            maximumFractionDigits: 0
        }).format(price);

        return `EUR ${number}`;
    },
    formatCodeFraction(price) {
        const number = new Intl.NumberFormat('cs-CZ', {
            style: 'decimal',
            maximumFractionDigits: 2
        }).format(price);

        return `EUR ${number}`;
    },
    previousStep() {

        if (this.form.currentStep === 'stepTwo') {
            this.form.steps.stepOne.filled = false;
            this.pscFilter();
            this.form.currentStep = 'stepOne';
            this.scrollTop();
        } else if (this.form.currentStep === 'stepThree') {
            this.form.steps.stepTwo.filled = false;
            this.form.currentStep = 'stepTwo';
            this.scrollTop();
        }

    },
    goToStep(stepName) {
        var step = null;
        if (stepName === 'stepOne') {
            step = this.form.steps.stepOne;
            if (step.visited) {
                step.filled = false;
                this.form.currentStep = 'stepOne';
                this.scrollTop();
            }
        } else if (stepName === 'stepTwo') {
            step = this.form.steps.stepTwo;
            if (step.visited) {
                step.filled = false;
                this.form.currentStep = 'stepTwo';
                this.scrollTop();
            }
        } else if (stepName === 'stepThree') {
            step = this.form.steps.stepThree;
            if (step.visited) {
                step.filled = false;
                this.form.currentStep = 'stepThree';
                this.scrollTop();
            }
        }

    },
    getPriceTotalZivnosti() {
        var zivnosti = this.order.products.filter(obj => {
            return obj.type === 'tradeType'
        });
        var price = 0;
        for (const element of zivnosti) {
            price += element.totalPriceWithoutVat;
        }
        return price;
    },

    getPriceSpravniPoplatek(){
        var prod = this.getOrderProduct('ZU01');
        return prod.prices.find(price => price.currency.priceListName === this.form.priceListName).price;
    },

    getSeatProduct() {
        if (this.order.seatChoose === 'virtual') {
            return this.order.products.filter(obj => {
                return obj.type === 'seat'
            });
        }
    },

    // filter
    pscFilter() {
        var psc = String(this.order.ownSeatAddress.psc);
        psc = psc.replace(' ', '');
        this.order.ownSeatAddress.psc = psc.slice(0, 3) + ' ' + psc.slice(3);
    },
    pscFilterInvoice() {
        var psc = String(this.order.contactInfo.psc);
        psc = psc.replace(' ', '');
        this.order.contactInfo.psc = psc.slice(0, 3) + ' ' + psc.slice(3);
    },
    phoneNumberSpacesFilter() {
        // console.log('dat mezery')
        // var phone = String(this.order.contactInfo.phone);
        // phone = phone.replace(' ', '');
        // if (phone.startsWith(this.order.contactInfo.phoneCountry.value)) {
        //     phone = phone.slice(this.order.contactInfo.phoneCountry.value.length)
        // }
        // this.order.contactInfo.phone = phone.slice(0, 3) + ' ' + phone.slice(3, 6) + ' ' + phone.slice(6);
        //
        if (store.order.contactInfo.phoneCountry.value !== 'other') {
            var phone = String(this.order.contactInfo.phone);
            phone = phone.replace(' ', '');
            phone = phone.replace('+', '');
            if (phone.startsWith(this.order.contactInfo.phoneCountry.value)) {
                phone = phone.slice(this.order.contactInfo.phoneCountry.value.length)
            }
            this.order.contactInfo.phone = phone.slice(0, 3) + ' ' + phone.slice(3, 6) + ' ' + phone.slice(6, 9) + ' ' + phone.slice(9);
        }
    },

    lettersInPhoneNumberInput() {
        // console.log('pryc pismena')
        // //store.order.contactInfo.phone = String(store.order.contactInfo.phone).replace(/(\+420)?(00420)?(\+1)?/g, '');
        //
        // store.order.contactInfo.phone = String(store.order.contactInfo.phone).replace(/\D/g, '');
        //
        store.order.contactInfo.phone = String(store.order.contactInfo.phone).replace(/\D/g, '');
        if (store.order.contactInfo.phoneCountry.value === 'other') {
            store.order.contactInfo.phone = '+' + store.order.contactInfo.phone;
        }
    },

    // U volby "Jiné" je předvolba už v čísle, text volby do telefonu nepatří.
    getFormattedPhoneNumber() {
        const o = this.order;
        if (!o.contactInfo.phoneCountry) return o.contactInfo.phone || '';
        if (o.contactInfo.phoneCountry.value === 'other') {
            return o.contactInfo.phone || '';
        }
        return o.contactInfo.phoneCountry.text + ' ' + (o.contactInfo.phone || '');
    },

    scrollTop() {

        let target = document.querySelector('#appJakeTrade');
        let headerOffset = 100;
        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    },
    scrollToErrorInput() {
        if (window.innerWidth <= 767) {
            let target = document.getElementsByClassName('is-invalid')[0];
            // console.log("scroll to error");
            // console.log("target: ", target);
            if (target) {
                let headerOffset = 100;
                let offsetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                // console.log("offsetPossition", offsetPosition);
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    },
    pushDataLayer(data) {
        // tracking nesmí rozbít odeslání formu (dataLayer chybí nebo ho stránka přepsala)
        try {
            window.dataLayer = window.dataLayer || [];
            return window.dataLayer.push(data);
        } catch (e) {
            console.error('dataLayer push selhal', e);
        }
    },
    sendGaEvent(label, event = 'tradeForm') {
        if (this.gaSwitch) {
            var ga = this.pushDataLayer({
                'event': 'tradeForm: ' + event,
                'event_category': 'Form',
                'event_action': 'Click',
                'event_label': label
            });
            console.log(ga, 'GA event');
        }
    },
    gaEventNextStep(toStep) {
        if (this.gaSwitch) {
            var url = window.location.href;
            var ga = this.pushDataLayer({
                'event': 'formNextStep',
                'event_category': 'Form',
                'event_action': 'Click',
                'event_label': 'tradeForm - ' + toStep + '(' + this.order.type + ') - ' + url
            });
            console.log(ga, 'GA event Next Step');
        }
    },
    gaEventFinishForm() {
        if (this.gaSwitch) {

            var url = window.location.href;

            var ga = this.pushDataLayer({
                'event': 'formConversion',
                'event_category': 'Form',
                'event_action': 'Click',
                'event_label': 'tradeForm - (' + this.order.type + ') - ' + url
            });
            if(this.order.type ==="demand"){
                this.gaEventFinishDemand()
            }
            // console.log(ga, 'GA event finish form');
        }
    },
    gaEventFinishDemand() {
        if (this.gaSwitch){
            const priceNoVat = this.calcOrderTotalPriceNoVat();
            const priceWithVat = this.calcOrderTotalPriceWithVat();
            this.pushDataLayer({
                "event": "generate_lead",
                lead_source: "Poptávka - vyřízení živnosti",
                value: priceNoVat, //celková hodnota všech produktů bez DPH
                tax: Math.round((priceWithVat - priceNoVat)*100)/100, //celková hodnota daně
                shipping: 0, //cena poštovného
                currency: import.meta.env.VITE_CURRENCY,
                items: this.createGaEventItemsData()
            })
        }
    },
    gaEventFinishOrder() {
        if (this.gaSwitch)
            this.pushDataLayer(this.createGaEventFinishOrderData());
    },
    createGaEventFinishOrderData() {
        const priceNoVat = this.calcOrderTotalPriceNoVat();
        const priceWithVat = this.calcOrderTotalPriceWithVat();
        return {
            "event": "purchase",
            transaction_id: this.order.uuid, //ID objednávky
            value: priceNoVat, //celková hodnota všech produktů bez DPH
            tax: Math.round((priceWithVat - priceNoVat)*100)/100, //celková hodnota daně
            shipping: 0, //cena poštovného, u J&J pravděpodobně všude nula
            currency: import.meta.env.VITE_CURRENCY,
            // coupon: "SLEVA20", // v tuto chvíli asi na webu nemáme podporu kupónů, kdyby se někdy objevila, může být v tomto poli
            payment_type: this.order.paymentType === 'payment.card' ? "karta" : "faktura", //způsob platby TODO kartou nebo bankou. má zde být tedy faktura a karta?
            items: this.createGaEventItemsData()
        }
    },
    createGaEventItemsData() {
        return this.order.products.map((item, index) => {
            return {
                item_id: item.code, //ID produktu v objednávce
                item_name: item.name, // název produktu
                index: index,
                coupon: "",
                discount: 0,
                item_brand: "Jake&James",
                // item_category: "Virtuální sídla",
                // item_category2: t('sidla' + seat.codeForTran).split('-')[0].split(' ')[0], // Praha/Brno
                // item_variant: t('sidla' + seat.codeForTran).split('-')[0], //Praha 2
                price: this.getGaEventItemPrice(item), //cenu a množství můžeme uvádět buď ve formátu cena za měsíc a počet měsíců nebo cena za rok a počet let, osobně preferuji spíš měsíce, kdyby se v budoucnu umožnila objednávka i na kratší období než je rok
                // promotion_id: "P_12345",
                // promotion_name: "Summer Sale",
                quantity: item.months ? parseInt(item.months) : 1 //pokud se rozhodneme pro cestu měsíční evidence, uvádíme jeden rok hodnotou 12
            }
        })
    },
    getGaEventItemPrice(item) {
        if (item.type === "seat") {
            return item.totalPriceWithoutVat / parseInt(item.months);
        } else if (item.code === "ZU01") {
            return this.getPriceSpravniPoplatek();
        } else return item.totalPriceWithoutVat
    },
    gaEventErrorForm(onStep) {
        if (this.gaSwitch) {

            var url = window.location.href;
            var ga = this.pushDataLayer({
                'event': 'formValidationError',
                'event_category': 'Form',
                'event_action': 'Validation',
                'event_label': 'tradeForm - ' + onStep + ' (' + this.order.type + ') - ' + url
            });
            console.log(ga, 'GA event validation error form');
        }
    },
    tradeClarityEvent(name) {
        var event_name = 'trade-order-form_' + name;
        this.clarityEvent(event_name);
    },
    vueClarityEvent(name) {
        var event_name = 'vue-form_' + name;
        this.clarityEvent(event_name);
    },
    clarityEvent(event_name) {
        // Clarity event
        if (typeof window.clarity === 'function') {
            clarity('event', event_name);
        } else {
           // console.warn('Clarity is not initialized');
        }
    }

})